import { useEffect, useState } from "react";
import { formatDateWithMin } from "../../utils/date";
import { TableWithSearchAndSortEngine } from "../utils/table";
import { CircularLoading } from "../utils/loading";
import { sendServerRequest } from "../../server/request";
import { openGlobalSnack } from "../utils/snack";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Tab } from "@mui/material";
import { normalizePhone } from "../../utils/phone";
import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import { PropostalStatus } from "../types/propostals";
import { CltDocPedency } from "./cltpedency";
import { CltPropostalCompleteInfo } from "./types";



function CompleteInfo({id,closed,uploadPropostals}:{id?:number,closed:Function,uploadPropostals:Function}){
    const [open,setOpen]=useState(false);
    const [loading,setLoading]=useState(false);
    const [propostal,setPropostal]=useState<undefined|CltPropostalCompleteInfo>();
    const [tabValue,setTabValue]=useState('1');
    const [blockOut,setBlockOut]=useState(false);
    const [renewLinkLoading,setRenewLinkLoading]=useState(false);
    useEffect(()=>{
       setOpen(Boolean(id));
       setTabValue('1');
       setBlockOut(false);
    },[id]);
    useEffect(()=>{
        if(!renewLinkLoading)return;
        sendServerRequest('POST',`/server/clt/propostal/renewlink/${id}`).then(e=>{
           openGlobalSnack('Link Atualizado Com Sucesso.','success');
           setLoading(true);
           setRenewLinkLoading(false);
        }).catch(e=>{
            setRenewLinkLoading(false);
            openGlobalSnack('Atualize a página','error');
        })
    },[renewLinkLoading])
    useEffect(()=>{
        if(open){
             setLoading(true);
        }
    },[open]);
    useEffect(()=>{
      if(!loading)return;
      sendServerRequest('GET',`/server/clt/propostal/${id}`).then(e=>{
           setPropostal(e.data.data);
           setLoading(false);
        }).catch(e=>{
            console.log(e);
            openGlobalSnack('Atualize a página','error');
        })
    },[loading]);
    return <Dialog open={open}>
        <DialogTitle>Proposta Empréstimo CLT</DialogTitle>
        <DialogContent>
            <TabContext value={loading?'1':tabValue}>
                 <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={(e,v)=>setTabValue(v)} centered={true}  aria-label="lab API tabs example">
                        <Tab label="Informações" value="1" />
                        <Tab label="Pendencia" value="2" disabled={!propostal||propostal.status!==PropostalStatus.pending} />
                    </TabList>
                </Box>
             <TabPanel value='1'>   
            {loading?<CircularLoading/>:<div>
                <p>{`Status: ${propostal?.status}`}</p>
                <p>{`Nome: ${propostal?.client.name}`}</p>
                <p>{`Nome Mae: ${propostal?.client.motherName}`}</p>
                <p>{`Telefone: ${propostal?.client.phone}`}</p>
                <p>{`Data de nascimento: ${propostal?.client.birthDate}`}</p>
                <p>{`CPF: ${propostal?.client.cpf}`}</p>
                <p>{`LINK: ${propostal?.link}`}</p>
                 <p>{`LINK LIGACAO: ${propostal?.callLink}`}</p>
                 {propostal?.status==PropostalStatus.formalization?<LoadingButton loading={renewLinkLoading} variant="contained" onClick={()=>{
                    const mc=window.confirm("Você realmente deseja renovar o link?");
                    if(!mc)return;
                    setRenewLinkLoading(true);
                 }}>Renovar Link De Formalização</LoadingButton>:null}
                {propostal?.history?<div style={{textAlign:'center',marginTop:'10px',marginBottom:'10px'}}>
                    <p>Histórico da proposta</p>
                </div>:null}
                {propostal?.history.map(e=>{
                    return <div style={{marginTop:'15px'}}>
                        <p>{`Açao: ${e.action}`}</p>
                        <p>{`Data: ${formatDateWithMin(e.createdAt)}`}</p>
                        {e.description?<p>{`Descriçao: ${e.description}`}</p>:null}
                        {e.reason?<p>{`Razão: ${e.reason}`}</p>:null}
                        <Divider/>
                    </div>
                })}
            </div>}
            </TabPanel>
            <TabPanel value='2'>
               {propostal?<CltDocPedency propostal={propostal} 
               onUploaded={
                    ()=>{
                        close();
                        uploadPropostals();
                    }
                }
               setBlockOut={setBlockOut}/>:null}
            </TabPanel>
            </TabContext>
        </DialogContent>
       <DialogActions>
         <Button disabled={blockOut}  variant="contained" onClick={close}>Sair</Button>
       </DialogActions>
    </Dialog>
    function close(){
        setOpen(false);
        setPropostal(undefined);
        closed();

    }
}

export function CltPropostal(){
    const [loading,setLoading]=useState(true);
    const [items,setItems]=useState([]);
    const [propostalId,setPropostalId]=useState<undefined|number>(undefined);
    useEffect(()=>{
        sendServerRequest('GET','/server/clt/propostals').then(e=>{
            setItems(e.data.data.propostals);
            setLoading(false);
        }).catch(e=>{
             openGlobalSnack('Atualize a página','error');
        })
    },[loading])
    return (
        <div>
            {loading?<CircularLoading/>:
         <div>
         <CompleteInfo uploadPropostals={()=>setLoading(true)} id={propostalId} closed={()=>setPropostalId(undefined)}/>
         <TableWithSearchAndSortEngine
          header={[
            {label:'CPF',id:'cpf'},
            {label:'Nome',id:'name'},
            {label:'Telefone',id:'phone',showValue:(i)=>normalizePhone(i.phone??'')},
            {label:'Status',id:'status',allowSort:true},
           
            {label:'Parcelas',id:'installments',allowSort:true},
            {label:'Valor',id:'liquidValue',allowSort:true},

            {label:'Data',id:'created_at',showValue:(i)=>formatDateWithMin(i.createdAt),allowSort:true},
            {label:'Ver Mais',id:'see_more',showValue:(i)=><Button variant="contained"
            onClick={()=>setPropostalId(i.id)}
            >Ver Mais</Button>}
          ]}
          filters={[{
            label:'Formalizaçao',
            filter:(i)=>i.status=='formalization'
          },{
            label:'Pendencia',
            filter:(i)=>i.status=='pending'
          },
          {
            label:'Analise Manual',
            filter:(i)=>i.status=='manual_analysis'
          },
        {
            label:'Cancelado',
            filter:(i)=>i.status=='canceled'
          }]}
          items={items}
        /></div>}
        </div>
    )
}